import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import jwtAuthAxios from "services/jwtAuth";

export const getJadwalDosen = createAsyncThunk("jadwalDosen/getJadwalDosen",
    async() => {
        try{
            let token = localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const url = `/v1/master/jadwal`
            const response = await jwtAuthAxios.get(url)
            return response.data
        } catch(error){
            console.error("Error fetching data:", error);
            throw error;
        }
    });

export const createJadwalDosen = createAsyncThunk("jadwalDosen/createJadwalDosen", async(payload) => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('/v1/master/jadwal', payload);
    return response.data;
});

export const updateJadwalDosen = createAsyncThunk("jadwalDosen/updateJadwalDosen", async(payload) => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.put('/v1/master/jadwal', payload);
    return response.data;
});

export const deleteJadwalDosen = createAsyncThunk("jadwalDosen/deleteJadwalDosen", async(id) => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.delete(`/v1/master/jadwal/${id}`);
    return response.data;
});


export const viewJadwalDosen = createAsyncThunk("jadwalDosen/viewJadwalDosen", async(payload) => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('/v1/jadwal/dosen/id', payload);
    return response.data;
});

export const viewListMhsKrsDosen = createAsyncThunk("jadwalDosen/viewListMhsKrsDosen", async(payload) => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('/v1/dosen/krs/list/mhs', payload);
    return response.data;
});

export const viewListMhsPenilaianDosen = createAsyncThunk("jadwalDosen/viewListPenilaianDosen", async(payload) => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('/v1/penilaian/dosen/list/mhs', payload);
    return response.data;
});

export const listMhsPenilainDosen = createAsyncThunk("jadwalDosen/listMhsPenilainDosen", async(payload) => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('/v1/dosen/input/nilai/list_mhs', payload);
    return response.data;
});



export const viewPenilaianDosen = createAsyncThunk("jadwalDosen/viewPenilaianDosen", async(payload) => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('/v1/penilaian/dosen/list/jadwal/param', payload);
    return response.data;
});

export const savePenilaianMhs = createAsyncThunk("jadwalDosen/savePenilaianMhs", async(payload) => {
    let token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('/v1/nilai/mahasiswa', payload);
    return response.data;
});



const initialState = {
    loading: false,
    jadwalDosen:[],
    listJadwal:[],
    listPenilaianDosen:[],
    listMhsPenilaianDosen:[],
    dataMhsPenilaianDosen:[],
    listKrsMhsFromDosen:[],
    response:[],
}

const jadwalDosenSlice = createSlice({
    name: "jadwalDosen",
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder
            .addCase(savePenilaianMhs.pending, (state) => {
                state.loading = true;
            })
            .addCase(savePenilaianMhs.fulfilled, (state, action) => {
                state.response = action.payload;
                state.loading = false;
            })
            .addCase(savePenilaianMhs.rejected, (state, action) => {
                state.loading = false;
                console.error("Error:", action.error);
            })

        builder
            .addCase(listMhsPenilainDosen.pending, (state) => {
                state.loading = true;
            })
            .addCase(listMhsPenilainDosen.fulfilled, (state, action) => {
                state.dataMhsPenilaianDosen = action.payload;
                state.loading = false;
            })
            .addCase(listMhsPenilainDosen.rejected, (state, action) => {
                state.loading = false;
                console.error("Error:", action.error);
            })
        builder
            .addCase(viewListMhsPenilaianDosen.pending, (state) => {
                state.loading = true;
            })
            .addCase(viewListMhsPenilaianDosen.fulfilled, (state, action) => {
                state.listMhsPenilaianDosen = action.payload;
                state.loading = false;
            })
            .addCase(viewListMhsPenilaianDosen.rejected, (state, action) => {
                state.loading = false;
                console.error("Error:", action.error);
            })
        builder
            .addCase(viewListMhsKrsDosen.pending, (state) => {
                state.loading = true;
            })
            .addCase(viewListMhsKrsDosen.fulfilled, (state, action) => {
                state.listKrsMhsFromDosen = action.payload;
                state.loading = false;
            })
            .addCase(viewListMhsKrsDosen.rejected, (state, action) => {
                state.loading = false;
                console.error("Error:", action.error);
            })

        builder
            .addCase(getJadwalDosen.pending, (state) => {
                state.loading = true;
            })
            .addCase(getJadwalDosen.fulfilled, (state, action) => {
                state.jadwalDosen = action.payload;
                state.loading = false;
            })
            .addCase(getJadwalDosen.rejected, (state, action) => {
                state.loading = false;
                console.error("Error:", action.error);
            })

        builder
            .addCase(viewPenilaianDosen.pending, (state) => {
                state.loading = true;
            })
            .addCase(viewPenilaianDosen.fulfilled, (state, action) => {
                state.listPenilaianDosen = action.payload;
                state.loading = false;
            })
            .addCase(viewPenilaianDosen.rejected, (state, action) => {
                state.loading = false;
                console.error("Error:", action.error);
            })
        builder
            .addCase(createJadwalDosen.pending, (state) => {
                state.loading = true;
            })
            .addCase(createJadwalDosen.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(createJadwalDosen.rejected, (state, action) => {
                state.loading = false;
                console.error("Error:", action.error);
            })
        builder
            .addCase(deleteJadwalDosen.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteJadwalDosen.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(deleteJadwalDosen.rejected, (state, action) => {
                state.loading = false;
                console.error("Error:", action.error);
            })
        builder
            .addCase(updateJadwalDosen.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateJadwalDosen.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(updateJadwalDosen.rejected, (state, action) => {
                state.loading = false;
                console.error("Error:", action.error);
            })
        builder
            .addCase(viewJadwalDosen.pending, (state) => {
                state.loading = true;
            })
            .addCase(viewJadwalDosen.fulfilled, (state, action) => {
                state.listJadwal = action.payload
                state.loading = false;
            })
            .addCase(viewJadwalDosen.rejected, (state, action) => {
                state.loading = false;
                console.error("Error:", action.error);
            })
    }
})

export const jadwalDosenSelector = (state) => state.jadwalDosen;
export default jadwalDosenSlice.reducer;


